import { actions } from "./featureFlagsSlice";
import RBAC, { userHasRole } from "../../General/roleModuleActions";
import { getUserView, getAllGlobalFlags } from "../../General/featureSwitchApi";

/**
 * Load feature flags for the current user.
 *  - StubUser → getUserView(userId), uses `effective` per task
 *  - Otherwise → getAllGlobalFlags(), uses `isEnabled` per task
 * On any error, marks loaded=true with empty map (consumers fall back to optimistic default).
 */
export const loadFeatureFlags = (user) => async (dispatch) => {
  if (!user?.userID) return;
  dispatch(actions.startLoad());
  try {
    // Tolerate camelCase, PascalCase, and ALLCAPS_ID variants in the response.
    const pickId = (o) => o?.taskID ?? o?.taskId ?? o?.TaskId ?? o?.TaskID ?? o?.id ?? o?.Id;
    const pickEnabled = (o) => o?.isEnabled ?? o?.IsEnabled ?? o?.enabled ?? o?.Enabled;
    const pickEffective = (o) => o?.effective ?? o?.Effective;
    const pickStubEnabled = (o) => o?.stubEnabled ?? o?.StubEnabled;

    if (userHasRole(user, RBAC.Role_StubUser)) {
      const res = await getUserView(user.userID);
      const r = res?.data?.result;
      const byTaskId = {};
      if (Array.isArray(r?.features)) {
        for (const f of r.features) {
          const id = pickId(f);
          if (id != null) byTaskId[Number(id)] = !!pickEffective(f);
        }
      }
      dispatch(
        actions.loadSucceeded({
          byTaskId,
          stubEnabled: !!pickStubEnabled(r),
        })
      );
    } else {
      const res = await getAllGlobalFlags();
      const list = Array.isArray(res?.data?.result)
        ? res.data.result
        : Array.isArray(res?.data?.data)
        ? res.data.data
        : Array.isArray(res?.data)
        ? res.data
        : [];
      const byTaskId = {};
      for (const it of list) {
        const id = pickId(it);
        if (id != null) byTaskId[Number(id)] = !!pickEnabled(it);
      }
      dispatch(actions.loadSucceeded({ byTaskId, stubEnabled: false }));
    }
  } catch (e) {
    dispatch(actions.loadFailed(e?.message || "load failed"));
  }
};
